export const PROJECT_PANEL_HEADER_HEIGHT = "9.1875rem";
